import { render, staticRenderFns } from "./LiveAccountAllTabs.vue?vue&type=template&id=34f63988"
import script from "./LiveAccountAllTabs.vue?vue&type=script&lang=js"
export * from "./LiveAccountAllTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports